import ReactTooltip from 'react-tooltip'

class AtmosicTip extends ReactTooltip {
    constructor(props) {
        super(props);
        this.dotheThing=this.dotheThing.bind(this)
    }
    dotheThing(e, isGlobalCall) {
        const originTooltip = e.currentTarget.getAttribute('data-tip');
        let pin = originTooltip;

        this.props.clickCallback(pin)
    }
    bindListener () {
        const {id, globalEventOff, isCapture} = this.props
        let targetArray = this.getTargetArray(id)

        targetArray.forEach(target => {
            const isCaptureMode = this.isCapture(target)
            const effect = this.getEffect(target)
            if (target.getAttribute('currentItem') === null) {
                target.setAttribute('currentItem', 'false')
            }
            this.unbindBasicListener(target)

            if (this.isCustomEvent(target)) {
                this.customBindListener(target)
                return
            }

            target.addEventListener('mouseenter', this.showTooltip, isCaptureMode)
            target.addEventListener('click', this.dotheThing, isCaptureMode)

            if (effect === 'float') {
                target.addEventListener('mousemove', this.updateTooltip, isCaptureMode)
            }
            target.addEventListener('mouseleave', this.hideTooltip, isCaptureMode)
        })

        // Global event to hide tooltip
        if (globalEventOff) {
            window.removeEventListener(globalEventOff, this.hideTooltip)
            window.addEventListener(globalEventOff, this.hideTooltip, isCapture)
        }

        // Track removal of targetArray elements from DOM
        this.bindRemovalTracker()
    }

}

export default AtmosicTip
